<template>
  <ReaderInterlude
    v-bind="$props"
    @openComments="emit('openComments')"
    :cardClass
  >
    <template #default v-if="$slots.next">
      <Card class="space-y-4" :class="cardClass">
        <h3 class="font-bold">
          {{ $t("components.reader.interlude.header.up_next") }}
        </h3>
        <slot name="next"></slot>
        <NamiButton
          button-type="primary"
          @buttonClick="emit('nextChapter')"
          block
          >{{
            $t(
              `components.reader.interlude.button.next.${chapterKind || "chapter"}`,
            )
          }}
        </NamiButton>
      </Card>
    </template>
    <template #share><slot name="share"></slot></template>
    <template #comments><slot name="comments"></slot></template>
  </ReaderInterlude>
</template>

<script setup lang="ts">
import type { ChapterKind } from "~/src/api";

const emit = defineEmits<{
  (e: "nextChapter"): void;
  (e: "openComments"): void;
}>();
defineProps<{
  chapterKind?: ChapterKind | null;
  cardClass?: string;
}>();
</script>
